const arsenal = [
  {
    id: "01",
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 26/27 - Uniforme 1",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2026", "2026 arsenal", "2026"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/26-27-01/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-01/uni1.jpg",
    ],
  },
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 26/27 - Uniforme 2",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2026", "2026 arsenal", "2026"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/26-27-02/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-02/uni1.jpg",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 26/27 - Uniforme de Pré Jogo",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2026", "2026 arsenal", "2026"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/26-27-05-pj/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-05-pj/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-05-pj/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-05-pj/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/26-27-05-pj/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-02/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-02/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-02/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-02/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-03/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-03/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-03/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-03/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme de Goleiro (Amarela)",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-01-ga/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01-ga/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01-ga/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01-ga/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-01-ga/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2025", "2025 arsenal", "2025"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/25-26-00-esp/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-esp/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-esp/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-esp/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/25-26-00-esp/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2024", "2024 arsenal", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/24-25-02/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-02/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-02/uni2.jpg",
    ],
  },
  {
    id: 9,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 24/25 - Uniforme de Treino (Preta)",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2024", "2024 arsenal", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/24-25-05-tp/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tp/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tp/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tp/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tp/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 24/25 - Uniforme de Treino (Roxa)",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2024", "2024 arsenal", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/24-25-05-tr/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tr/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tr/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tr/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-05-tr/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 24/25 - Jaqueta (Vermelha)",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "jaqueta arsenal",
      "arsenal jaqueta",
      "jaqueta",
      "arsenal 2024",
      "2024 arsenal",
      "2024",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/24-25-09-jv/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-09-jv/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-09-jv/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-09-jv/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/24-25-09-jv/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 23/24 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2023", "2023 arsenal", "2023"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/23-24-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/23-24-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/23-24-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/23-24-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/23-24-00-es/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2022", "2022 arsenal", "2022"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/22-23-01/uni0.jpeg",
      "/images/inglaterra/premier-league/arsenal/22-23-01/uni1.jpeg",
      "/images/inglaterra/premier-league/arsenal/22-23-01/uni2.jpeg",
      "/images/inglaterra/premier-league/arsenal/22-23-01/uni3.jpeg",
    ],
  },
  {
    id: 14,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 22/23 - Uniforme de Treino (Azul)",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2022", "2022 arsenal", "2022"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/22-23-05-ta/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/22-23-05-ta/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/22-23-05-ta/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/22-23-05-ta/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/22-23-05-ta/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2021", "2021 arsenal", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/21-22-01/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-01/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-01/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-01/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2021", "2021 arsenal", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/21-22-03/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-03/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-03/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-03/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 21/22 - Uniforme de Treino (Azul)",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2021", "2021 arsenal", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/21-22-05-ta/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-ta/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-ta/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-ta/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-ta/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 21/22 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: ["arsenal", "gunners", "arsenal 2021", "2021 arsenal", "2021"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/21-22-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/21-22-00-es/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 21/22 - Jaqueta (Vermelha)",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "jaqueta arsenal",
      "arsenal jaqueta",
      "jaqueta",
      "arsenal 2021",
      "2021 arsenal",
      "2021",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/21-22-05-jv/uni0.jpeg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-jv/uni1.jpeg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-jv/uni2.jpeg",
      "/images/inglaterra/premier-league/arsenal/21-22-05-jv/uni3.jpeg",
    ],
  },
  {
    id: 21,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 16/17 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2016",
      "2016 arsenal",
      "2016",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/16-17-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/16-17-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/16-17-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/16-17-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/16-17-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 12-13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2012",
      "2012 arsenal",
      "2012",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/12-13-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/12-13-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/12-13-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/12-13-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 07/08 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2007",
      "2007 arsenal",
      "2007",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 07/08 - Uniforme Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2007",
      "2007 arsenal",
      "2007",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt1/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt1/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt1/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt1/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/07-08-03-rt1/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 05/06 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2005",
      "2005 arsenal",
      "2005",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/05-06-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 05/06 - Uniforme 2 Retrô Manga Longa",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2005",
      "2005 arsenal",
      "2005",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/05-06-02-rt-mc/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-02-rt-mc/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-02-rt-mc/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-02-rt-mc/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/05-06-02-rt-mc/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 02/03 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 2002",
      "2002 arsenal",
      "2002",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/02-03-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/02-03-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/02-03-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/02-03-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/02-03-01-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 99/00 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 1999",
      "1999 arsenal",
      "1999",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/99-00-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/99-00-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/99-00-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/99-00-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/99-00-01-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 1998",
      "1998",
      "1998",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/98-99-01/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/98-99-01/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/98-99-01/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/98-99-01/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/98-99-01/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 1997",
      "1997",
      "1997",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/97-98-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/97-98-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/97-98-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/97-98-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 94/95 - Uniforme de Goleiro (Prata) Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 1994",
      "1994",
      "1994",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/94-95-05-gp-rt/uni0.jpg",
      "/images/inglaterra/premier-league/arsenal/94-95-05-gp-rt/uni1.jpg",
      "/images/inglaterra/premier-league/arsenal/94-95-05-gp-rt/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/94-95-05-gp-rt/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/94-95-05-gp-rt/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 92/93 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "arsenal",
      "gunners",
      "retro arsenal",
      "arsenal retro",
      "retro",
      "arsenal 1992",
      "1992",
      "1992",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/arsenal/92-93-02/uni0.jpeg",
      "/images/inglaterra/premier-league/arsenal/92-93-02/uni1.jpeg",
      "/images/inglaterra/premier-league/arsenal/92-93-02/uni2.jpg",
      "/images/inglaterra/premier-league/arsenal/92-93-02/uni3.jpg",
      "/images/inglaterra/premier-league/arsenal/92-93-02/uni4.jpg",
    ],
  },
];

export default arsenal;
